import { Link } from 'react-router-dom'
import { useTranslation } from 'react-i18next'
import { Button } from './Button'

export function NotFoundPage() {
  const { t } = useTranslation()
  
  return (
    <div className="min-h-[60vh] flex items-center justify-center px-4">
      <div className="text-center">
        <div className="mb-8">
          <h1 className="text-6xl font-bold text-gray-300 dark:text-gray-700">{t('footer.404')}</h1>
          <h2 className="text-2xl font-semibold text-gray-900 dark:text-gray-100 mb-2">
            {t('errors.pageNotFound')}
          </h2>
          <p className="text-gray-600 dark:text-gray-400 mb-8">
            {t('errors.pageNotFoundDescription')}
          </p>
        </div>
        
        <Link to="/">
          <Button variant="primary">
            {t('common.goHome')}
          </Button>
        </Link>
      </div>
    </div>
  )
}